import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useRef, useState } from 'react';
import RawHtml from '../RawHtml/RawHtml';
import useStyles from './FaqItem.styles';
const FaqItem = (props) => {
    const { id, question, answer, onlyLinks, anchorKey, questionTag } = props;
    const { classes } = useStyles();
    const [open, setOpen] = useState(false);
    const accordianRef = useRef(null);
    // On page load, scrollIntoView if hash in url
    useEffect(() => {
        var _a, _b;
        if (!!anchorKey && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hash) === `#${anchorKey}`) {
            (_b = accordianRef === null || accordianRef === void 0 ? void 0 : accordianRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: 'smooth' });
            setOpen(true);
        }
    }, [anchorKey]);
    const showAnswer = (id) => {
        const element = document.getElementById(`Q-${id}`);
        element === null || element === void 0 ? void 0 : element.click();
    };
    const headingComponent = (questionTag ? questionTag.toLowerCase() : 'h3');
    if (onlyLinks) {
        return (_jsx("div", { children: id && (_jsx("a", { onClick: () => showAnswer(id), className: classes.accordianLink, href: `#Q-${id}`, target: "_self", children: question })) }));
    }
    if (question && answer) {
        return (_jsxs(Accordion, { className: classes.accordian, expanded: open, ref: accordianRef, slotProps: { heading: { component: headingComponent } }, children: [_jsx(AccordionSummary, { id: `Q-${id}`, onClick: () => setOpen((prev) => !prev), classes: {
                        root: classes.accordianSummaryRoot,
                        content: classes.accordianSummaryContent,
                        expandIconWrapper: classes.accordianSummaryExpandIcon,
                    }, expandIcon: _jsx(ExpandMoreIcon, { className: classes.expandIcon }), "aria-controls": `panel${id}-content`, children: question }), _jsx(AccordionDetails, { classes: { root: classes.accordianDetailsRoot }, children: _jsx(RawHtml, { className: classes.accordianAnswer, content: answer }) })] }, id));
    }
    return null;
};
export default FaqItem;
